import { useEffect, useState } from 'react'
import MyCart from "./MyCart";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import SuccessBee from "../../../../../assets/images/SuccessBee.svg";
import { CONSTANTS } from 'client/utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import navOperations from "redux/Navigation/operations";
import { removeBulkOrderAttachment, setIsApprovalOverride, setOrderCartData, setOrderData, setSelectedCostCenter, setSelectedOrderType } from 'Store/Component/BulkOrder/BulkOrderAction';
import { useNavigate } from 'react-router-dom';
import { ReactToAPI } from 'Service/BulkOrder/objectStructure';
import { setSaveBulkOrder } from 'Store/OrderManagement/BulkOrderSave/BulkOrderSaveAction';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import { popupInitialData } from 'utils';

const MyCartContainer = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
  const setdeletedItemFromCart = props?.setdeletedItemFromCart;

  const [expandAll, setExpandAll] = useState(true)
  const [grandTotal, setGrandTotal] = useState<any>();
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

  const [cancelPopupcontent, setCancelPopupcontent] = useState<any>(popupInitialData);

  const { cartDetails,
    selectedCostCenter,
    isApprovalOverride,
    userDetails,
    orderDetails,
    bulkOrderSaveValue,
    BulkOrdeByIdValue,
    activeNavigation,
    isCostCenterAvailableForSubmit }: any = useSelector((state?: any) => ({
      cartDetails: state.BulkOrderReducer.orderCartDetails,
      selectedCostCenter: state.BulkOrderReducer.selectedCostCenter,
      isApprovalOverride: state.BulkOrderReducer.isApprovalOverride,
      userDetails: state.UserProfile.getUserDetails,
      orderDetails: state.BulkOrderReducer.orderDetails,
      bulkOrderSaveValue: state.BulkOrderSaveReducer.bulkOrderSaveValue,
      BulkOrdeByIdValue: state.BulkOrdeByIdReducer.bulkOrderbyIdValue,
      activeNavigation: state.nav.nav,
      isCostCenterAvailableForSubmit: state.TransferReducer.isCostCenterAvailableForSubmit
    }));

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  };

  const hideDialogCancel = () => {
    setCancelPopupcontent({ ...cancelPopupcontent, isDialogVisible: false })
  };
  const navigateToBulkOrderHome = () => {
    dispatch(setOrderCartData([]))
    dispatch(setSelectedCostCenter({}))
    dispatch(setSelectedOrderType({}))
    dispatch(setIsApprovalOverride(false))
    dispatch(setOrderData([]))
    dispatch(setSaveBulkOrder({}))
    dispatchNav(activeNavigation);
    dispatchHeaderNav(activeNavigation);
    navigate('/ordermanagement')
  }
  const popupOutlinebtnOnclick = () => {
    hideDialog();
    dispatch(RequisitionAction.setIsChangesOccured(false));
    navigateToBulkOrderHome()
  };

  const popupOutlinebtnOnclickCancel = () => {
    hideDialogCancel();
  };

  const popupPrimarybtnOnclickCancel = () => {
    hideDialogCancel();
    navigateToBulkOrderHome()
  };

  const submitValues = (item: any) => {
    let orderId = BulkOrdeByIdValue != null ? BulkOrdeByIdValue?.orderId : 0
    ReactToAPI({
      dispatch,
      orderId,
      cartDetails,
      selectedCostCenter,
      item,
      userDetails,
      orderDetails,
      isApprovalOverride
    })
  }

  const handleClickSubmit = (item?: any) => {
    if (item == "Submit") {
      let cartEquipments = cartDetails?.length ? JSON.parse(JSON.stringify(cartDetails)) : []
      let orderDetailEquipment = orderDetails ? JSON.parse(JSON.stringify(orderDetails)) : []
      let cartCountTemp: any = []
      let orderDetailCountTemp: any = []
      cartEquipments?.map((item: any) => {
        item?.requests?.map((requestItems: any) => {
          cartCountTemp.push(requestItems?.equipmentIndex)
        })
      })
      orderDetailEquipment?.map((item: any) => {
        if (item?.requestType == CONSTANTS?.VEHICLE_REQUEST) {
          orderDetailCountTemp.push(item?.equipmentIndex)
        } else {
          item?.selectedCatalogItems?.map((orderRequestItems: any) => {
            orderDetailCountTemp.push(orderRequestItems?.equipmentIndex)
          })
        }
      })

      let unAddedEquipment = orderDetailCountTemp?.filter((item: any) => !cartCountTemp?.includes(item))

      let cartRequestIndexArr = cartEquipments?.map((item: any) => (item?.requestIndex))
      let unAddedItem = orderDetails?.filter((item: any) => !cartRequestIndexArr?.includes(item?.requestIndex))
      if (unAddedEquipment?.length || unAddedItem?.length) {
        let decriptionTxt = (<>
          <p>Please provide details for all added items.</p>
        </>);
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: CONSTANTS.TITLE_CONFIRMATION,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "Ok",
          popupOutlinebtnOnclick: () => {
            hideDialog();
          },
          isSingleConfirmationBtn: true,
        });
      } else {
        submitValues(item)
      }
    } else {
      submitValues(item)
    }

  }

  const handleClickCancel = () => {
    let decriptionTxt = (
      <p>Are you sure you want to cancel the New Order?</p>
    );
    setCancelPopupcontent({
      ...cancelPopupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      popupPrimarybtnOnclick: popupPrimarybtnOnclickCancel,
      popupOutlinebtnOnclick: popupOutlinebtnOnclickCancel,
      isSingleConfirmationBtn: false,
    });
  };

  useEffect(() => {
    let vehicleReqList: any = []
    let managedEquipmentList: any = []
    let cartList: any = []
    cartDetails?.map((item?: any, index?: any) => {
      if (item?.orderType == CONSTANTS?.VEHICLE_REQUEST) {
        vehicleReqList?.push(item)
      } else {
        managedEquipmentList?.push(item)
      }
    })
    if (vehicleReqList?.length) {
      let obj: any = {}
      obj.type = CONSTANTS?.VEHICLE_REQUEST
      obj.searchCriteria = vehicleReqList
      cartList.push(obj)
    }
    if (managedEquipmentList?.length) {
      let obj: any = {}
      obj.type = CONSTANTS.MANAGED_EQUIPMENT
      obj.searchCriteria = managedEquipmentList
      cartList.push(obj)
    }
    setrequestTypeList(cartList)
  }, [cartDetails])

  const [requestTypeList, setrequestTypeList] = useState<any>();
  const handleCollapseClick = (itemIndex: any, requestIndex: any, index: any) => {
    let requestTypeListTemp = JSON.parse(JSON.stringify(requestTypeList))
    requestTypeListTemp[itemIndex].searchCriteria[requestIndex].requests[index].collapse = !requestTypeListTemp[itemIndex].searchCriteria[requestIndex].requests[index].collapse
    setrequestTypeList(requestTypeListTemp)
  }

  const handleClickExpandAll = () => {
    setExpandAll(!expandAll)
    let requestTypeListTemp = JSON.parse(JSON.stringify(requestTypeList))
    requestTypeList?.map((itemVal?: any, itemIndex?: any) => {
      itemVal?.searchCriteria?.map((searchItem?: any, searchIndex?: any) => {
        if (searchItem?.requests?.length) {
          searchItem?.requests?.map((requestItem: any, requestIndex: any) => {
            requestItem.collapse = expandAll
          })
        }
      })
    })
    setrequestTypeList(requestTypeListTemp)
  }

  useEffect(() => {
    let total = 0
    requestTypeList?.map((itemVal?: any, itemIndex?: any) => {
      itemVal?.searchCriteria?.map((searchItem?: any, searchIndex?: any) => {
        if (searchItem?.requests?.length) {
          searchItem?.requests?.map((requestItem: any, requestIndex: any) => {
            total = total + (Number(requestItem?.quantity) * Number(requestItem?.price))
          })
        }
      })
    })
    setGrandTotal(total)
  }, [requestTypeList])

  const getCartCount = () => {
    let count = 0
    requestTypeList?.map((itemVal?: any, itemIndex?: any) => {
      itemVal?.searchCriteria?.map((requestVal: any) => {
        count = count + requestVal?.requests?.length
      })
    })
    return count
  }

  const getRequestLength = (val: any) => {
    let requestCount = 0;
    val?.map((searchItem?: any, searchIndex?: any) => {
      if (searchItem?.requests?.length) {
        requestCount = requestCount + searchItem?.requests?.length
      }
    })
    return requestCount
  }

  const onClickDeleteFromCart = (e: any, item: any, itemIndex: any, requestIndex: any, requestItem: any) => {
    let cartDetailsTemp = JSON.parse(JSON.stringify(cartDetails))
    cartDetailsTemp?.map((searchItem: any, searchIndex: any) => {
      searchItem?.requests?.map((itemVal: any, itemValIndex: any) => {
        if (item?.equipmentIndex == itemVal?.equipmentIndex && searchItem?.requestIndex == requestIndex) {
          if (searchItem?.requests?.length == 1) {
            cartDetailsTemp?.splice(searchIndex, 1)
          } else {
            searchItem?.requests?.splice(itemValIndex, 1)
          }
        }
      })
    })
    dispatch(setOrderCartData(cartDetailsTemp))
    
    const tempOrderRemovedData = JSON.parse(JSON.stringify(orderDetails))?.filter((equipmentRequest: any) => equipmentRequest?.requestIndex === requestIndex)
    if (tempOrderRemovedData[0]?.selectedCatalogItems?.length > 1) {
      orderDetails?.map((equipmentItem?: any) => {
        if (equipmentItem?.requestIndex === requestIndex) {
          equipmentItem?.selectedCatalogItems?.map((requestItem?: any, valueIndex?: any) => {
            if (requestItem?.assetModelId === item?.assetModelId) {
              setdeletedItemFromCart(item?.assetModelId)
              equipmentItem?.selectedCatalogItems?.splice(valueIndex, 1)
            }
          })
        }
      })
      dispatch(setOrderData(orderDetails))
    } else {
      const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.filter((equipmentRequest: any) => equipmentRequest?.requestIndex !== requestIndex)
      dispatch(setOrderData(tempOrderData))
      dispatch(removeBulkOrderAttachment([], requestIndex))
    }
  }

  useEffect(() => {
    if (bulkOrderSaveValue?.hasOwnProperty("isSaved")) {
      let decriptionTxt
      if (bulkOrderSaveValue?.isSaved) {
        if (bulkOrderSaveValue?.type == "Submit") {
          decriptionTxt = (<>
            <p>Bulk Order has been created successfully.</p>
            <p><b>LEADR ORDER #: </b> {bulkOrderSaveValue?.savedOrderNo}</p>
          </>);
        } else {
          decriptionTxt = (<>
            <p>Bulk Order has saved as a draft.</p>
          </>);
        }
        setPopupcontent({
          ...Popupcontent,
          titleImg: SuccessBee,
          title: CONSTANTS.TITLE_SUCCESS,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "Close",
          popupOutlinebtnOnclick: popupOutlinebtnOnclick,
          isSingleConfirmationBtn: true,
        });
      } else {
        decriptionTxt = bulkOrderSaveValue?.errorMessage?.length ? (<>
          <p>{bulkOrderSaveValue?.errorMessage}</p>
        </>) : (<>
          <p>Error occured while {bulkOrderSaveValue?.type == "Submit" ? "submitting" : "saving"} the bulk order request.</p>
        </>)

        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: bulkOrderSaveValue?.errorMessage?.length ? "WARNING" : CONSTANTS.TITLE_CONFIRMATION,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "Close",
          popupOutlinebtnOnclick: () => {
            hideDialog();
          },
          isSingleConfirmationBtn: true,
        });
      }

    }
  }, [bulkOrderSaveValue])

  return (
    <MyCart
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      handleClickSubmit={handleClickSubmit}
      cancelPopupcontent={cancelPopupcontent}
      hideDialogCancel={hideDialogCancel}
      handleClickCancel={handleClickCancel}
      showCart={props?.showCart}
      handleCollapseClick={handleCollapseClick}
      requestTypeList={requestTypeList}
      expandAll={expandAll}
      handleClickExpandAll={handleClickExpandAll}
      grandTotal={grandTotal}
      getCartCount={getCartCount}
      onClickDeleteFromCart={onClickDeleteFromCart}
      getRequestLength={getRequestLength}
      selectedCostCenter={selectedCostCenter}
      BulkOrdeByIdValue = {BulkOrdeByIdValue}
      isCostCenterAvailableForSubmit = {isCostCenterAvailableForSubmit}
    />
  )
}

export default MyCartContainer;